
import { DiscountCode } from "@/models/discount-code";
import { IDataTableColumn } from "winfakt-vue-components/src/classes";
import Vue from "vue";
import { toDateString } from "@/utils/strings";
import { DiscountCodeService } from "@/services/discount-code-service";
import { IPaginationData } from "@/utils/browse/pagination-data";
import { Route } from "vue-router/types";

export default Vue.extend({
	data(){
		return {
			ready: false,
			codes: [] as DiscountCode[],
			selectedItems: [] as DiscountCode[],
			orderColumn: "id",
			orderDirection: false,
			total: 0,
			limit: 20,
			page: 1,
			currentQueryId: 0.0,
		};
	},
	computed: {
		// eslint-disable-next-line max-lines-per-function
		columns():IDataTableColumn[]{
			return [
				{
					name: "ID",
					property: "id",
					width: "50px"
				},
				{
					name: "Code",
					property: "code",
					width: "200px"
				},
				{
					name: "Percentage",
					property: "percentage",
					width: "50px",
					print(value:number):string{
						return `${value}%`;
					},
					right: true
				},
				{
					name: "Van",
					property: "from",
					width: "100px",
					print: toDateString
				},
				{
					name: "Tot",
					property: "till",
					width: "100px",
					print: toDateString
				},
				{
					name: "Max aantal keren gebruikt",
					property: "uses",
					width: "50px",
					print(value:number):string {
						if (value == -1){
							return "Onbeperkt";
						}
						return `${value}`;
					}
				}
			];
		},
		pageCount():number {
			return this.total / this.limit;
		},
		editDisabled():boolean {
			return this.selectedItems.length != 1;
		},
		removeDisabled():boolean {
			return this.selectedItems.length == 0;
		},
		showTotalRecordsText():string {
			if (this.total != 1) {
				return this.total +" record's found";
			}
			return this.total + " record found";
		},
		limits():any[] {
			let limits = [1, 2, 5, 10, 20, 25, 50, 100, 200, 250, 500];
			return limits.map(l => {
				return {
					text: "Limit " + l + " records",
					value: l
				};
			});
		},
	},
	watch: {
		limit() {
			if (this.pageCount > this.page){
				this.page = this.pageCount;
			}
			this.getCodes();
		},
		page() {
			this.getCodes();
		},
		orderColumn() {
			this.getCodes();
		},
		orderDirection() {
			this.getCodes();
		},
	},
	methods: {
		async getCodes(){
			if (!this.ready) return;
			let id = Math.random();
			this.currentQueryId = id;
			this.setQuery();
			let data:IPaginationData = {
				limit: this.limit,
				offset: Math.floor((this.page - 1) * this.limit),
				order: this.orderColumn,
				ascending: this.orderDirection
			};
			let response = await DiscountCodeService.getDiscountCodes(data);
			if (this.currentQueryId != id) return;
			this.codes = response.data;
			this.total = response.records;
			if (this.page != 1 && this.codes.length == 0){
				this.page = 1;
				await this.getCodes();
			}
		},
		setQuery(){
			let path = `/discount-code?limit=${this.limit}&page=${this.page}&orderColumn=${this.orderColumn}&orderDirection=${this.orderDirection}`;
			if ((this.$route as Route).fullPath != path){
				this.$router.push(path);
			}
		},
		add(){
			this.$router.push(`/discount-code/new`);
		},
		edit(){
			this.$router.push(`/discount-code/edit/${this.selectedItems[0].id}`);
		},
		async remove(){
			let confirm = await this.$wf.confirm(`Weet je zeker dat je ${this.selectedItems.length} codes wilt verwijderen?`, "Ja", "Nee", "Waarschuwing");
			if (!confirm) return;
			await DiscountCodeService.deleteDiscountCodes(this.selectedItems);
			this.getCodes();
		},
		setPage(value:number){
			this.page = Math.round(value);
		},
	},
	async created(){
		if (this.$route.query.limit){
			this.limit = parseInt(this.$route.query.limit as string) || this.limit;
		}
		if (this.$route.query.page){
			this.page = parseInt(this.$route.query.page as string) || 1;
		}
		if (this.$route.query.orderColumn){
			this.orderColumn = this.$route.query.orderColumn as string;
		}
		if (this.$route.query.orderDirection){
			this.orderDirection = this.$route.query.orderDirection == "true";
		}
		if (this.orderColumn == "") {
			this.orderColumn = "id";
		}
		if (this.limit == 0){
			this.limit = 25;
		}
		if (this.page == 0){
			this.page = 1;
		}

		this.ready = true;
		this.getCodes();
	}
});
